<template>
  <v-card flat class="pa-4">
    <v-switch v-model="preferences.duration" label="Track fermentation duration" dense/>
    <v-switch v-model="preferences.incomplete" label="Allow incomplete savings" dense/>
    <v-switch v-model="preferences.ph" label="Track pH and Specific Gravity" dense/>
    <v-switch v-model="preferences.brix" label="Use Brix instead of Specific Gravity" dense/>
    <v-switch v-model="preferences.lot" label="Allow produced wine lot to be specified" dense/>
    <v-row dense class="mt-4">
      <v-col cols="3 pt-3">Numbering</v-col>
      <v-col cols="3">
        <v-text-field label="Prefix" v-model="preferences.numberPrefix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="Suffix" v-model="preferences.numberSuffix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <decimal-number-input label="Start at" v-model="preferences.numberStart" :precision="0" integer prefix=""/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'ProductionWineFermentingPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation ProductionWineFermentingPreferences($input:WineFermentationPreferencesInput!) {
                                              wineFermentationSetPreferences(input:$input) {
                                                brix, duration, incomplete, ph, lot
                                                numberPrefix, numberSuffix, numberStart
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.wineFermentationSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query ProductionWineFermentingPreferences {
                                          wineFermentationPreferences {
                                            brix, duration, incomplete, ph, lot
                                            numberPrefix, numberSuffix, numberStart
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.wineFermentationPreferences;
  }
}
</script>